module.exports = __webpack_public_path__ + "img/J12871.b8ac2d53.png";